export enum FleetSurveyAction {
  Submitted = 'SUBMITTED',
  Ignored = 'IGNORED',
}
